import { AppTheme } from './../../../../theme/useTheme';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: AppTheme) => ({
  container: {
    height: '100%',
    position: 'relative',
  },
  model: {
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    zIndex: 0,
  },
  button: {
    position: 'absolute',
    right: theme.spacing(1),
    bottom: theme.spacing(1),
    zIndex: 1,
    padding: theme.spacing(1),
    minWidth: 0,
    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },
    backgroundColor: theme.palette.background.default,
  },
}));